import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import NavbarTop from "components/navbar/top/NavbarTop";
import NavbarVertical from "components/navbar/vertical/NavbarVertical";
import Footer from "components/footer/Footer";
import ProductProvider from "providers/ProductProvider";
import CourseProvider from "providers/CourseProvider";

import { useAppContext } from "providers/AppProvider";
import { useSelector } from "react-redux";
import paths from "routes/paths";

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes("kanban");
  // const isChat = pathname.includes('chat');

  const navigate = useNavigate();

  const { userData } = useSelector((state) => state.auth);

  const getToken = localStorage.getItem("bearerToken");
  useEffect(() => {
    if (!getToken) {
      navigate(paths.login, { replace: true });
    }
  }, [getToken]);

  const {
    config: { isFluid, navbarPosition },
  } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div
      className={isFluid ? "container-fluid pl-2 ml-2" : "container pl-2 ml-2"}
    >
      {(navbarPosition === "vertical" || navbarPosition === "combo") && (
        <NavbarVertical />
      )}
      <ProductProvider>
        <CourseProvider>
          <div className={classNames("content", { "pb-0": isKanban })}>
            <NavbarTop />
            {/*------ Main Routes ------*/}
            <Outlet />
          </div>
        </CourseProvider>
      </ProductProvider>
    </div>
  );
};

export default MainLayout;
